module.exports = __webpack_public_path__ + "img/web2.9fd17ca9.svg";